module.exports = __webpack_public_path__ + "static/media/icone-parlamentar-relatorio.287e1cc6.svg";